import { render, staticRenderFns } from "./chat-input.vue?vue&type=template&id=113323e8&scoped=true&"
import script from "./chat-input.vue?vue&type=script&lang=js&"
export * from "./chat-input.vue?vue&type=script&lang=js&"
import style0 from "./chat-input.vue?vue&type=style&index=0&id=113323e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113323e8",
  null
  
)

export default component.exports